<template>
  <el-drawer :visible.sync="visible" size="75%" custom-class="purchaser-settle-price">
    <template slot="title">
      <div>
        <span class="div_detail_name">{{ detail.row.ID > 0 ? detail.row.Name : '' }}</span>
        <span class="div_detail_title">客户价管理</span>
      </div>
    </template>
    <el-container>
      <el-main>
        <div class="action-button">
          <span>
            <el-input v-model="detailSearchItemNo" placeholder="请输入货号" style="width: 180px; margin-right: 5px" :clearable="true" />
            <el-button type="primary" @click="handleDetailSearch">搜索</el-button>
          </span>
          <span>
            <el-button type="primary" plain icon="el-icon-plus" @click="handleAddDetail" :disabled="detail.row.ID <= 0">
              新增特殊客户价
            </el-button>
            <el-button type="danger" plain icon="el-icon-delete" @click="handleDeleteDetail(null)" :disabled="detail.row.ID <= 0">
              删除
            </el-button>
          </span>
        </div>
        <div class="div_detail_all">
          <div>
            该客户
            <span class="red">所有商品</span>
            默认客户价比商品价便宜：￥
            <el-input-number
              v-model="priceDiscount"
              :min="0"
              :controls="false"
              :disabled="detail.row.ID <= 0"
              placeholder="请输入"
              style="width: 60px; margin-right: 5px"
            ></el-input-number>
            <el-button type="primary" @click="handlePriceDiscountChange" :disabled="detail.row.ID <= 0">设置</el-button>
          </div>
          <div class="span_detail_tip">价格优先级：黑色-36 > 全部-36 > 黑色-全部 > 全部-全部 > 规格价</div>
        </div>
        <el-table
          ref="detailTable"
          :data="detail.rowDetails"
          v-loading="detail.loading"
          border
          :row-class-name="handleRowClassName"
          :header-cell-style="{
            'background-color': '#E5EEF6',
            'border-color': 'rgba(218, 223, 228, 1)',
            height: '48px',
          }"
          @selection-change="handleDetailSelectionChange"
          height="100%"
        >
          <el-table-column type="selection" width="39" align="center" />
          <el-table-column prop="ItemNo" label="货号" align="center" :filters="itemNoFilters" :filter-method="handleFilter" />
          <el-table-column prop="Color" label="颜色" align="center" :filters="colorFilters" :filter-method="handleFilter">
            <template slot-scope="{ row }">
              {{ row.Color }}
            </template>
          </el-table-column>
          <el-table-column prop="Size" label="尺码" align="center" />
          <el-table-column prop="Price" label="商品价" align="center">
            <template slot-scope="{ row }">
              {{ $store.state.routes.systemSetting.IsHideProductPriceAuth ? '**' : row.Price }}
            </template>
          </el-table-column>
          <el-table-column prop="SettlePrice" label="客户价" align="center">
            <template slot-scope="{ row }">
              <template v-if="row.SettleType == 0">
                <strong>固定价：</strong>
                ￥{{ $store.state.routes.systemSetting.IsHideCustomerPriceAuth ? '**' : row.SettlePrice }}
              </template>
              <template v-if="row.SettleType == 1">
                <strong>便宜：</strong>
                ￥{{ $store.state.routes.systemSetting.IsHideCustomerPriceAuth ? '**' : row.SettlePrice }}
                <span class="span_wname">
                  (即：{{ $store.state.routes.systemSetting.IsHideCustomerPriceAuth ? '**' : row.Price - row.SettlePrice }})
                </span>
              </template>
            </template>
          </el-table-column>
          <el-table-column prop="OP" label="操作" width="180" align="center">
            <template slot-scope="{ row }">
              <el-button type="primary" plain size="mini" @click="handleEditDetail(row)">编辑</el-button>
              <el-button type="danger" plain size="mini" @click="handleDeleteDetail(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div>
          <el-button type="primary" plain @click="visible = false">关闭</el-button>
        </div>
      </el-main>
    </el-container>
    <settle-price-edit ref="settlePriceDialog" v-if="settlePriceDialogVisible" @handleCallback="handleSettlePriceCallback" />
  </el-drawer>
</template>

<script>
import { submit } from '@/api/base'
import SettlePriceEdit from '@/views/stall/purchaser/components/SettlePriceEdit.vue'

export default {
  name: 'SettlePriceList',
  components: {
    SettlePriceEdit,
  },
  data() {
    return {
      visible: false,
      detail: {
        loading: false,
        row: { ID: 0, Name: '' },
        rowDetails: [],
        rowSourceDetails: [],
      },
      detailSearchItemNo: '',
      priceDiscount: 0,
      itemNoFilters: [],
      colorFilters: [],
      detailSelectRows: [],
      settlePriceDialogVisible: false,
    }
  },
  methods: {
    async show(row) {
      this.visible = true
      await this.getSettlePriceList(row)
      let _this = this
      this.$nextTick(() => {
        let deletedList = _this.detail.rowDetails.filter(t => t.IsDelete)
        if (deletedList.length > 0) {
          _this.doDeleteDetail(
            '检测到客户【' + row.Name + '】的客户价列表中有 ' + deletedList.length + ' 条记录的商品、规格不存在或已删除，是否删除？',
            { PurchaserID: row.PurchaserID, NotExists: true }
          )
        }
      })
    },
    async getSettlePriceList(row) {
      this.detail.loading = true
      const { data } = await submit(`/api/stall/getPriceDetails`, {
        PurchaserID: row.PurchaserID,
      })
      this.detail.row = { ...row }
      this.detail.rowDetails = this.sortDetails(data ?? [])
      var itemNos = {}
      var colors = {}
      for (let i = 0; i < this.detail.rowDetails.length; i++) {
        var item = this.detail.rowDetails[i]
        itemNos[item.ItemNo] = 1
        colors[item.Color] = 1
      }
      for (let key in itemNos) {
        this.itemNoFilters.push({ text: key, value: key })
      }
      for (let key in colors) {
        this.colorFilters.push({ text: key, value: key })
      }
      this.itemNoFilters = this.itemNoFilters.sort(function (a, b) {
        if (a.ItemNo !== b.ItemNo) return a.ItemNo < b.ItemNo ? -1 : 1
      })
      this.colorFilters = this.colorFilters.sort(function (a, b) {
        if (a.Color !== b.Color) return a.Color < b.Color ? -1 : 1
      })
      this.priceDiscount = this.detail.row.PriceDiscount
      this.detail.rowSourceDetails = [...this.detail.rowDetails]
      this.detail.loading = false
    },
    clear() {
      this.detail.row = { ID: 0, Name: '' }
      this.detail.rowDetails = []
      this.detail.rowSourceDetails = []
      this.detail.price_discount = 0
      this.detailSearchItemNo = ''
      this.priceDiscount = 0
      this.itemNoFilters = []
      this.colorFilters = []
      this.detailSelectRows = []
    },
    sortDetails(data) {
      return data.sort(function (a, b) {
        if (a.ProductID !== b.ProductID) return a.ProductID < b.ProductID ? -1 : 1
        else if (a.Color !== b.Color) return a.Color < b.Color ? -1 : 1
        else if (a.Size !== b.Size) return a.Size < b.Size ? -1 : 1
      })
    },
    doDeleteDetail(conformText, param) {
      var _this = this
      this.$confirm(conformText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '正在提交中...'
            let data = await submit('/api/stall/deletePriceDetails', param).catch(error => {
              instance.confirmButtonLoading = false
              instance.confirmButtonText = '确认'
              done()
            })
            _this.$message({
              type: data.success ? 'success' : 'error',
              message: data.msg,
            })
            instance.confirmButtonLoading = false
            _this.getSettlePriceList(_this.detail.row)
            done()
          } else {
            done()
          }
        },
      })
    },
    handleDetailSearch() {
      let details = [...this.detail.rowSourceDetails]
      let _this = this
      if (this.detailSearchItemNo != '') {
        details = details.filter(x => x.ItemNo.toUpperCase().indexOf(_this.detailSearchItemNo.toUpperCase()) >= 0)
      }
      this.detail.rowDetails = details
    },
    handleDetailSelectionChange(selection) {
      this.detailSelectRows = selection
    },
    handleFilter(value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    async handlePriceDiscountChange() {
      if (this.detail.row.ID <= 0) {
        return
      }
      const res = await submit('/api/stall/savePurchaser', {
        Purchaser: {
          PurchaserID: this.detail.row.PurchaserID,
          PriceDiscount: this.priceDiscount,
        },
        ChangeType: 'PriceDiscount',
      }).catch(error => {
        this.$message.error('设置失败')
      })
      if (!res.success) {
        this.$message.error(res.msg)
        return
      }
      this.$message.success('设置成功')
      this.$emit('priceDiscountChange', this.detail.row.PurchaserID, this.priceDiscount)
    },
    handleAddDetail() {
      this.settlePriceDialogVisible = true
      let _this = this
      this.$nextTick(() => {
        _this.$refs.settlePriceDialog.open(_this.detail.row)
      })
    },
    handleEditDetail(row) {
      this.settlePriceDialogVisible = true
      let _this = this
      this.$nextTick(() => {
        _this.$refs.settlePriceDialog.open(_this.detail.row, row.ItemNo)
      })
    },
    handleSettlePriceCallback() {
      this.getSettlePriceList(this.detail.row)
    },
    handleDeleteDetail(row) {
      var ids = []
      var conformText = ''
      if (row == null) {
        if (this.detailSelectRows.length <= 0) {
          this.$message({ type: 'error', message: '请选择要删除的数据' })
          return
        }
        this.detailSelectRows.forEach(t => {
          ids.push(t.ID)
        })
        conformText = '确定要删除选中的 ' + ids.length + ' 条客户价记录？'
      } else {
        ids.push(row.ID)
        conformText = '确定要删除当前客户价记录？'
      }
      this.doDeleteDetail(conformText, { PurchaserID: this.detail.row.PurchaserID, IDs: ids }, this.detail.row)
    },
    handleRowClassName({ row }) {
      let className = []
      if (row.IsDelete) {
        className = 'is-deleted'
      }
      return className
    },
  },
}
</script>

<style lang="scss" scoped>
.red {
  color: red;
}

::v-deep {
  .el-main {
    display: flex;
    flex-direction: column;

    > div:last-child {
      margin: 8px 5px 4px 0;
      text-align: right;
    }
  }

  .el-table {
    flex: 1;
  }

  .purchaser-settle-price {
    .el-drawer__header {
      padding: 10px 10px 0 !important;
      margin-bottom: 5px !important;
    }
  }
}

.span_wname {
  color: #9e9e9e;
  font-size: 12px;
}

.div_detail_name {
  font-weight: bold;
  font-size: 30px;
  line-height: 42px;
  margin-right: 10px;
  color: #333;
}

.div_detail_title {
  font-weight: normal;
  font-size: 24px;
  line-height: 42px;
  color: #333;
}

.action-button,
.div_detail_all {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
}

.div_detail_all {
  font-size: 15px;
  margin: 8px 0;

  .span_detail_tip {
    color: #9e9e9e;
    font-size: 13px;
    margin-left: 10px;
  }
}
</style>
